import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import swal from "sweetalert";
import Footer from "../components/Footer";
import AnimatedPage from "../components/AnimatedPage";
import { useForm } from "react-hook-form";

// Hàm lấy tên viết tắt chuẩn để gọi Logo VietQR
const getVietQRShortName = (bankName) => {
    if (!bankName) return "";
    const nameStr = bankName.toUpperCase().trim();
    if (nameStr.includes("VIETCOMBANK")) return "VCB";
    if (nameStr.includes("TECHCOMBANK")) return "TCB";
    if (nameStr.includes("VIETINBANK")) return "ICB"; 
    if (nameStr.includes("VPBANK")) return "VPB";
    if (nameStr.includes("KIENLONGBANK")) return "KLB";
    if (nameStr.includes("TPBANK")) return "TPB";
    if (nameStr.includes("MBBANK") || nameStr === "MB BANK" || nameStr === "MB") return "MB";
    if (nameStr.includes("AGRIBANK")) return "VBA";
    if (nameStr.includes("SACOMBANK")) return "STB";
    if (nameStr.includes("SEABANK")) return "SEAB";
    return nameStr;
};

function AddMoney() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [payment, setPayment] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // State chứa danh sách ngân hàng & ngân hàng đang chọn
    const [bankList, setBankList] = useState([]); 
    const [selectedBank, setSelectedBank] = useState(null);

    // State lưu phương thức đang chọn (Mặc định chọn Ngân Hàng)
    const [selectedMethod, setSelectedMethod] = useState('BANK'); 
    const [amount, setAmount] = useState("");

    const { register, handleSubmit, reset } = useForm();
    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const fetchData = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                if (JSON.stringify(profile) !== JSON.stringify(res.data.data)) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            }).catch(() => localStorage.removeItem("user"));
            
        axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`)
            .then((res) => {
                if (res.data.data) setPayment(res.data.data);
            }).catch(() => {});
    };

    useEffect(() => {
        fetchData();
            
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`)
            .then((res) => {
                if(res.data.data) {
                    setSetting(res.data.data[0]);
                }
            });

        // GỌI API LẤY DANH SÁCH NGÂN HÀNG KHẢ DỤNG
        axios.get(`${process.env.REACT_APP_API_URL}/bank/getBanks`)
            .then((res) => {
                if (res.data && res.data.success) {
                    setBankList(res.data.data);
                    // Tự động chọn ngân hàng đầu tiên nếu có
                    if(res.data.data.length > 0) {
                        setSelectedBank(res.data.data[0].bankCode);
                    }
                }
            })
            .catch((err) => console.log("Lỗi lấy danh sách ngân hàng:", err));
    }, []);

    const handleSelectAmount = (val) => {
        setAmount(val.toLocaleString("vi-VN"));
    };

    const handleInputChange = (e) => {
        const rawValue = e.target.value.replaceAll(".", "").replaceAll(",", "");
        if (!isNaN(rawValue) && rawValue !== "") {
            setAmount(Number(rawValue).toLocaleString("vi-VN"));
        } else {
            setAmount("");
        }
    };

    // ============================================
    // HÀM TẠO ĐƠN NẠP TIỀN TỰ ĐỘNG (BANK / VÍ ĐIỆN TỬ)
    // ============================================
    const handleCreateInvoice = (e) => {
        e.preventDefault();
        const rawAmount = Number(amount.replaceAll(".", "").replaceAll(",", ""));

        if (rawAmount <= 0 || isNaN(rawAmount)) {
            return swal("Thông báo", "Vui lòng nhập số tiền hợp lệ", "error");
        }
        if (setting && rawAmount < setting.minnap) {
            return swal("Chú ý", `Số tiền nạp tối thiểu là ${(setting.minnap).toLocaleString('vi-VN')}`, "warning");
        }
        if (setting && rawAmount > setting.maxnap) {
            return swal("Chú ý", `Số tiền nạp tối đa là ${(setting.maxnap).toLocaleString('vi-VN')}`, "warning");
        }

        if (payment) {
            const count = payment.filter((obj) => obj.status_payment === "Pending" && obj.type_payment === "NẠP");
            if (count.length >= 15) {
                return swal("Thông báo", `Bạn đang có lệnh nạp tiền chưa xử lý. Vui lòng thanh toán hoặc chờ hệ thống.`, "error");
            }
        }

        // Khởi tạo các giá trị cổng mặc định
        let gateCode = "003";
        let typeName = "bank";
        let finalBankCode = null;

        // Định tuyến tham số chuẩn theo từng Tab
        if (selectedMethod === 'BANK') {
            if (!selectedBank) return swal("Thông báo", "Vui lòng chọn ngân hàng bạn muốn nạp", "error");
            finalBankCode = selectedBank;
            gateCode = "003";
            typeName = "bank";
        } else if (selectedMethod === 'MOMO') {
            gateCode = "004";
            typeName = "momo";
        } else if (selectedMethod === 'ZALOPAY') {
            gateCode = "005";
            typeName = "zalopay";
        } else if (selectedMethod === 'VIETTELPAY') {
            gateCode = "006";
            typeName = "viettelmoney";
        }

        setLoading(true);

        const payload = { 
            amount: rawAmount,
            gate: gateCode,
            type: typeName,
            bankCode: finalBankCode
        };

        axios.post(`${process.env.REACT_APP_API_URL}/bank/createTrans`, payload)
        .then((res) => {
            setLoading(false);
            window.location.href = res.data.data.url;
        })
        .catch((err) => {
            setLoading(false);
            swal("Thất bại", err.response?.data?.message || "Hệ thống nạp tiền đang bảo trì", "error");
        });
    };

    // ============================================
    // HÀM SUBMIT MÃ KHUYẾN MÃI (GIFTCODE)
    // ============================================
    const onSubmitGiftCode = (data) => {
        if (!data.code) {
            return swal("Thông báo", "Vui lòng nhập mã nhận thưởng", "warning");
        }
        
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/promo/active`, { code: data.code })
            .then((res) => {
                setLoading(false);
                swal("Thành Công", `Nhận thành công ${res.data.data.money.toLocaleString("vi-VN")}₫.`, "success");
                reset(); 
                fetchData(); 
            })
            .catch((err) => {
                setLoading(false);
                const msg = err.response?.data?.message || "Đã xảy ra lỗi";
                swal("Thất bại", msg, "error");
            });
    };

    const amountOptions = [
         { label: "50.000", value: 50000 },
        { label: "100.000", value: 100000 },
        { label: "500.000", value: 500000 },
        { label: "1.000.000", value: 1000000 },
        { label: "5.000.000", value: 5000000 },
        { label: "10.000.000", value: 10000000 },
        { label: "50.000.000", value: 50000000 },
        { label: "100.000.000", value: 100000000 },
        { label: "300.000.000", value: 300000000 }
    ];

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#fff", overflow: "hidden" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                
                .d-app-main {
                    position: fixed; top: 0; bottom: 60px; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #fff; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                    z-index: 10;
                }
                .d-app-main::-webkit-scrollbar { display: none; }
                .d-app-main { -ms-overflow-style: none; scrollbar-width: none; }

                .d-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; border-bottom: 1px solid #f0f0f0; background: #fff;
                    position: sticky; top: 0; z-index: 50;
                }
                .d-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .d-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; margin-right: -24px;}
                .d-header-right { cursor: pointer; color: #f39c12; display: flex; align-items: center;}

                /* MENU CHỌN CỔNG CHÍNH (BANK, MOMO, ZALO...) */
                .d-bank-grid {
                    display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding: 15px;
                }
                .d-bank-item {
                    border: 1px solid #e0e0e0; border-radius: 6px; padding: 12px 10px;
                    display: flex; align-items: center; justify-content: flex-start; gap: 8px;
                    cursor: pointer; transition: 0.2s; background: #fff;
                }
                .d-bank-item.active { border-color: #25aae1; color: #25aae1; background: #f4fafe; }
                .d-bank-item img { border-radius: 4px; object-fit: contain; }
                .d-bank-item span { font-size: 13px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

                /* DANH SÁCH LOGO NGÂN HÀNG BÊN TRONG */
                .d-sub-bank-grid {
                    display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; padding: 0 15px 15px 15px;
                }
                .d-sub-bank-item {
                    border: 1px solid #e0e0e0; border-radius: 6px; padding: 10px 5px;
                    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px;
                    cursor: pointer; transition: 0.2s; background: #fff;
                }
                .d-sub-bank-item.active {
                    border-color: #25aae1; background: #f4fafe; box-shadow: 0 0 0 1px #25aae1;
                }
                .d-sub-bank-item img { height: 26px; width: 100%; object-fit: contain; }
                .d-sub-bank-item span { font-size: 11px; font-weight: 600; color: #555; text-align: center; }

                .d-note-box { padding: 0 15px 15px 15px; font-size: 13px; color: #333; line-height: 1.6; }

                .d-amount-grid {
                    display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; padding: 0 15px 15px 15px;
                }
                .d-amount-btn {
                    border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px 0;
                    text-align: center; font-size: 13px; font-weight: 500; color: #555;
                    background: #fff; cursor: pointer;
                }
                .d-amount-btn:active { background: #f0f0f0; }

                .d-input-group { padding: 0 15px 30px 15px; }
                .d-input-label { font-size: 14px; font-weight: 700; color: #333; margin-bottom: 8px; display: block; }
                .d-input-field {
                    width: 100%; padding: 12px 15px; border: 1px solid #ddd; border-radius: 6px;
                    font-size: 15px; outline: none; margin-bottom: 20px; transition: border 0.3s;
                }
                .d-input-field:focus { border-color: #25aae1; }
                
                .d-submit-btn {
                    width: 100%; background: #25aae1; color: #fff; border: none;
                    border-radius: 6px; padding: 14px 0; font-size: 16px; font-weight: 600;
                    cursor: pointer; transition: opacity 0.2s;
                }
                .d-submit-btn:active { opacity: 0.8; }
            `}} />

            {loading && <div className="loading" style={{zIndex: 99999}}><div className="loader"></div></div>}

            <div className="d-app-main">
                <AnimatedPage>
                    <div>
                        <div className="d-header">
                            <div className="d-header-back" onClick={() => navigate(-1)}>
                                <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                            </div>
                          <div className="d-header-title">Nạp tiền tự động</div>
                            <Link to="/transaction/history" state={{ filterType: 'nap' }} className="d-header-right">
                                <img src={require("../../images/moi/history_dark.png")} alt="Lịch sử" style={{ width: "24px", height: "24px", objectFit: "contain" }} />
                            </Link>
                        </div>

                        {/* GRID DANH SÁCH 5 PHƯƠNG THỨC THANH TOÁN */}
                        <div className="d-bank-grid">
                            <div 
                                className={`d-bank-item ${selectedMethod === 'BANK' ? 'active' : ''}`}
                                onClick={() => setSelectedMethod('BANK')}
                            >
                                <img src="https://cdn-icons-png.flaticon.com/512/2830/2830284.png" alt="Bank" style={{ width: "20px", height: "20px" }} />
                                <span>NGÂN HÀNG</span>
                            </div>

                            <div 
                                className={`d-bank-item ${selectedMethod === 'MOMO' ? 'active' : ''}`}
                                onClick={() => setSelectedMethod('MOMO')}
                            >
                                <img src="https://cdn.haitrieu.com/wp-content/uploads/2022/10/Logo-MoMo-Square.png" alt="Momo" style={{ width: "20px", height: "20px" }} />
                                <span>MOMO</span>
                            </div>

                            <div 
                                className={`d-bank-item ${selectedMethod === 'ZALOPAY' ? 'active' : ''}`}
                                onClick={() => setSelectedMethod('ZALOPAY')}
                            >
                                <img src="https://cdn.haitrieu.com/wp-content/uploads/2022/10/Logo-ZaloPay-Square.png" alt="ZaloPay" style={{ width: "20px", height: "20px" }} />
                                <span>ZALOPAY</span>
                            </div>

                            <div 
                                className={`d-bank-item ${selectedMethod === 'VIETTELPAY' ? 'active' : ''}`}
                                onClick={() => setSelectedMethod('VIETTELPAY')}
                            >
                                <img src="https://brandlogos.net/wp-content/uploads/2021/10/ViettelPay-logo-1.png" alt="ViettelPay" style={{ width: "20px", height: "20px" }} />
                                <span>VIETTELPAY</span>
                            </div>

                            <div 
                                className={`d-bank-item ${selectedMethod === 'GIFTCODE' ? 'active' : ''}`}
                                onClick={() => setSelectedMethod('GIFTCODE')}
                            >
                                <img src={require("../../images/moi/giftcode.png")} alt="Giftcode" style={{ width: "20px", height: "20px" }} />
                                <span>GIFTCODE</span>
                            </div>
                        </div>

                        {/* NẾU CHỌN NGÂN HÀNG -> HIỂN THỊ THÊM LƯỚI LOGO CÁC BANK ĐỂ CHỌN */}
                        {selectedMethod === 'BANK' && bankList.length > 0 && (
                            <div className="d-sub-bank-grid">
                                {bankList.map((bank, index) => {
                                    const shortName = getVietQRShortName(bank.bankName);
                                    return (
                                        <div 
                                            key={index} 
                                            className={`d-sub-bank-item ${selectedBank === bank.bankCode ? 'active' : ''}`}
                                            onClick={() => setSelectedBank(bank.bankCode)}
                                        >
                                            <img 
                                                src={`https://api.vietqr.io/img/${shortName}.png`} 
                                                alt={bank.bankName} 
                                                onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/2830/2830284.png" }} 
                                            />
                                            <span>{bank.bankName}</span>
                                        </div>
                                    )
                                })}
                            </div>
                        )}

                        {/* KHỐI LAYOUT KHI CHỌN CÁC TAB NẠP TIỀN (BANK / MOMO / ZALOPAY / VIETTELPAY) */}
                        {selectedMethod !== 'GIFTCODE' && (
                            <>
                             

                                <div className="d-amount-grid">
                                    {amountOptions.map((opt, idx) => (
                                        <div key={idx} className="d-amount-btn" onClick={() => handleSelectAmount(opt.value)}>
                                            {opt.label}
                                        </div>
                                    ))}
                                </div>

                                <div className="d-input-group">
                                    <label className="d-input-label">Số tiền cần nạp:</label>
                                    <input 
                                        type="text" 
                                        className="d-input-field" 
                                        placeholder="Nhập số tiền" 
                                        value={amount}
                                        onChange={handleInputChange}
                                    />
                                    <button className="d-submit-btn" onClick={handleCreateInvoice}>Nạp ngay</button>
                                </div>
                            </>
                        )}

                        {/* KHỐI LAYOUT KHI CHỌN TAB GIFTCODE */}
                        {selectedMethod === 'GIFTCODE' && (
                            <>
                                <div className="d-note-box" style={{borderBottom: '1px solid #eee', paddingBottom: '15px', marginBottom: '15px'}}>
                                    <div style={{marginBottom: '10px'}}>Chọn lời nhắc thanh toán:</div>
                                    <div>1. Nhập mã nhận thưởng vào ô bên dưới.</div>
                                    <div>2. Khi nhập đúng mã, điểm sẽ tự động cộng vào tài khoản.</div>
                                </div>

                                <form className="d-input-group" onSubmit={handleSubmit(onSubmitGiftCode)}>
                                    <label className="d-input-label">Mã nhận thưởng</label>
                                    <input 
                                        type="text" 
                                        className="d-input-field" 
                                        placeholder="Nhập mã nhận thưởng" 
                                        {...register("code", { required: true })}
                                    />
                                    <button type="submit" className="d-submit-btn">Xác nhận</button>
                                </form>
                            </>
                        )}
                    </div>
                </AnimatedPage>
            </div>
        </div>
    );
}

export default AddMoney;